/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { List } from 'immutable'
import { SegmentValueState } from '../state/SegmentValueState'
import SegmentationEvent from '../../event/SegmentationEvent'

class SegmentValuesStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List.of(new SegmentValueState())
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case SegmentationEvent.addRow:
        return state.push(new SegmentValueState())

      case SegmentationEvent.fetchOne:
        return List(payload.segment_values.map(v => new SegmentValueState(v)))

      case SegmentationEvent.onEditValue:
        const values = state.setIn([payload.index, payload.name], payload.value)
        return List(values)

      case SegmentationEvent.onDeleteValue:
        return state.remove(payload.index)

      case SegmentationEvent.onClear:
        return List.of(new SegmentValueState())

      default:
        return state
    }
  }
}

export default new SegmentValuesStore()
